<template>
  <div class="filter">
    <div class="form-control">
      <input type="text" placeholder="Поиск по вопросам." v-model="question">
    </div>
  </div>
</template>

<script>

import {computed, ref, watch} from 'vue'

  export default {
    emits: ['update:modelValue'],
    setup(_, {emit}) {
      const question = ref('')

      watch(question, value => {
        emit('update:modelValue', {
          question: value
        })
      })

      return {
        question,
      }
    }
  }
</script>

<style scoped>

.filter {
  width: 1000px;
  margin-top: 50px;
}

.form-control {
  position: relative;
  margin-bottom: 0.5rem;
}

.form-control input,
.form-control select,
.form-control textarea{
  font-family: Inter, Roboto, Oxygen, Fira Sans, Helvetica Neue, sans-serif;
  margin: 0;
  outline: none;
  border: 2px solid #ccc;
  display: block;
  width: 100%;
  color: #2c3e50;
  padding: 0.5rem 1.5rem;
  border-radius: 3px;
  font-size: 1rem;
  resize: none;
}

.form-control label {
  display: block;
  margin: 0 0 0.3rem 0.3rem;
  font-weight: 500;
}

.form-control input:active,
.form-control input:focus {
  transition: border 0.22s;
  border: 4px solid orange;
}

@media (max-width: 1200px) {
  .filter {
    width: 800px;
  }
}

@media (max-width: 900px) {
  .filter {
    width: 600px;
  }
}

@media (max-width: 700px) {
  .filter {
    width: 300px;
  }
}



</style>